import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';
import { SearchComponent } from './search.component';
import {SearchCriteriaModule} from '../project/searchFilter/search-criteria.module';
import {PaginationModule} from '../project/pagination/pagination.module';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    MaterialModule,
    SearchCriteriaModule,
    PaginationModule
  ],
  declarations: [SearchComponent],
  providers: [],
  exports: [SearchComponent]
})

export class SearchModule {

}
